import { FIVE_DAY_EXPECTATIONS } from "@/components/sample/fiveDayProtocol";
import { ProtocolIntroduction, ProtocolDirections } from "@/components/sample/ProtocolDirections";

export const FeedbackProtocolReview = () => (
  <div className="min-w-0" data-testid="feedback-protocol-review">
    <div className="sample-accent label !text-[8.5px]" data-testid="feedback-protocol-label">The five-day protocol</div>
    <h2 className="sample-editorial-strong editorial mt-4 text-3xl leading-tight" data-testid="feedback-protocol-title">Five days in. How did you feel?</h2>
    <ProtocolIntroduction prefix="feedback" />
    <ProtocolDirections prefix="feedback" />
  </div>
);

export const FeedbackProtocolReflections = () => (
  <div className="mt-6 border-t border-white/15 pt-4" data-testid="feedback-protocol-reflections">
    <h3 className="label !text-[8px] !text-white/55" data-testid="feedback-expectations-title">What to expect</h3>
    <div className="mt-4 space-y-4">
      {FIVE_DAY_EXPECTATIONS.map(([day, copy]) => (
        <p key={day} className="grid grid-cols-[42px_minmax(0,1fr)] gap-3 text-[13px] leading-relaxed" data-testid={`feedback-expectation-day-${day}`}>
          <span className="sample-accent font-mono" data-testid={`feedback-expectation-label-${day}`}>Day {day}</span>
          <span className="text-white/75" data-testid={`feedback-expectation-copy-${day}`}>— {copy}</span>
        </p>
      ))}
    </div>
    <p className="mt-5 text-[11px] text-white/50" data-testid="feedback-results-note">Individual experiences vary.</p>
  </div>
);